import { Button } from "@shared/components";
import { root } from "@shared/utils";
import cx from "classnames";
import PropTypes from "prop-types";
import React, { useCallback, useLayoutEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import AuthForm from "../../Form/AuthForm";

const AuthPopup = ({ loading, onAuthEnter }) => {
  const [isPopupShown, setIsPopupShown] = useState(false);
  const togglePopup = () => setIsPopupShown(!isPopupShown);
  const dropDownOpenClass = cx({ dropdown_opened: isPopupShown });

  const handleOutsideClick = useCallback(
    (event) => {
      const container = document.getElementById("loginDropDown");
      if (isPopupShown && container && !container.contains(event.target)) {
        setIsPopupShown(false);
      }
    },
    [isPopupShown]
  );

  useLayoutEffect(() => {
    root.addEventListener("click", handleOutsideClick);
    return () => root.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);
  return (
    <div className="login">
      <div
        id="loginDropDown"
        className={`sign-in dropdown ${dropDownOpenClass}`}
      >
        <Button
          variant="secondary"
          className="dropwdown__opener"
          tagName="div"
          onClick={togglePopup}
        >
          <FormattedMessage id="sign-in" />
        </Button>

        <div id="dropDownLogin" className="dropdown__drop">
          <AuthForm loading={loading} onAuthEnter={onAuthEnter} />
        </div>
      </div>
    </div>
  );
};

export default AuthPopup;

AuthPopup.propTypes = {
  onAuthEnter: PropTypes.func.isRequired,
};
